import { useState, useEffect, useRef } from "react";
import { FormField } from '@prosolve/common-components-ui'

export default ({
  formData
}) => {

  const selectorRef = useRef()

  const [searchVal, setSearchVal] = useState('')

  const onDependenciesChange = (dependencyName) => {
    const updatedValues = {
      ...formData.values,
      teamColor: ''
    }

    if (dependencyName === 'accountId') {
      updatedValues.implementationId = ''
      updatedValues.classId = ''
    } else if (dependencyName === 'implementationId') {
      updatedValues.classId = ''
    }

    formData.setValues(updatedValues)
    if (selectorRef.current && selectorRef.current.clearInput) {
      selectorRef.current.clearInput()
    }
  }

  useEffect(() => {
    onDependenciesChange('accountId')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values.accountId])

  useEffect(() => {
    onDependenciesChange('implementationId')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values.implementationId])

  useEffect(() => {
    onDependenciesChange('classId')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values.classId])

  const options = ['Green','Blue','Yellow','Purple','Black','Red']
    .filter(val => val.toLowerCase().indexOf(searchVal.toLowerCase()) > -1)
    .map(val => ({ value: val, text: val }))

  if (searchVal === '') {
    options.unshift({ value: '', text: '', display: 'All' })
  }

  return (
    <FormField
      ref={selectorRef}
      style={{ flex: 1 }}
      width='100%'
      fieldId='teamColor'
      type='search'
      label='Team'
      formData={formData}
      options={options}
      suppressAutoClearOnFocus={true}
      // isLoading={loading}
      onSearch={(val) => { setSearchVal(val) }}
      placeholder='All'
      maxHeight='200px'
    />
  )
}